import React from 'react';
import ReactDOM from 'react-dom';
import PersonalWebsite from './PersonalWebsite';

ReactDOM.render(
  <React.StrictMode>
    <PersonalWebsite />
  </React.StrictMode>,
  document.getElementById('root')
);